window.UpdateAddressForm = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            textBox: {
                postCode: '#health-address-post-code',
                savedAddressLine4: '#saved-address-Line4'
            },
            button:{
                findAddress: '#health-address-button-lookup'
            },
            label:{
                invalidPostCodeMessage: '#invalid-post-code',
                selectPostcodeAddressSection: '#select-postcode-address-sec',
                emptyPostCodeMessage: '#empty-post-code',
                selectAddressErrorMessage: '#select-address-error',
                savePostCodeInvalid: '#save-post-code-invalid'
            },
            select:{
                postCodeDropDown:'#select-postcode-address'
            },
            div:{
                multiLineAddressSection: '#multiline-address-section'
            },
            form:{
                healthAddressForm:'#health-address-form'
            }
        },
        css: {
            invalidFormInput: 'vds-form__input--invalid',
            hideElement:'vds-hide'
        },
        urls: {
            personalDetailsPageUrl: '/my-account/details',
            errorPageUrl: '/error/error-page',
            validatePostCodeUrl:'/api/sitecore/UpdateAddress/ValidatePostCode',
            updateAddressUrl:'/api/sitecore/UpdateAddress/UpdatePostCodeAddress'
        },
        constants: {
            postCodeLength: 10,
            address: 'address',
            replaceWhiteSpaceRegex: /\s+/g,
            splitLastThreeRegex: /(?=.{3}$)/
        },
        statusDescription: {
            accepted: 'accepted'
        },
        globalVariable:{
            isSelectPopulated: false
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.form.healthAddressForm).on('submit', self.func.handleSaveAddress);
                $(self.elements.textBox.postCode).on('keypress', self.func.allowLetterNumber);
                $(self.elements.textBox.postCode).on('input', self.func.allowCapsLetterOnly);
                $(self.elements.button.findAddress).on('click',self.func.formattedPostCode);
                $(self.elements.select.postCodeDropDown).on('change', self.func.onPostCodeDropDownChange);
            },
            allowLetterNumber: function (e) {
                const char = String.fromCharCode(e.which);
                const inputValue = e.target.value;
                if(inputValue !== '' && inputValue.length >= self.constants.postCodeLength) {
                    e.preventDefault();
                }
                if (!/^[a-zA-Z0-9\s]$/.test(char)) {
                    e.preventDefault();
                }
            },
            handleSaveAddress: function (event) {
                event.preventDefault();
                self.func.hideErrorMessage();
                if(!self.func.isValidPostCode()){
                    return;
                }
                if(!self.globalVariable.isSelectPopulated){
                    $(self.elements.label.savePostCodeInvalid).removeClass(self.css.hideElement);
                    return;
                }
                const selectedAddr = $(self.elements.select.postCodeDropDown).find(':selected').data(self.constants.address);
                if(self.globalVariable.isSelectPopulated && selectedAddr === undefined) {
                    $(self.elements.label.selectAddressErrorMessage).removeClass(self.css.hideElement);
                    return;
                }
                const postCodeAddress = {
                    Line1: selectedAddr.line1,
                    Line2: selectedAddr.line2,
                    Line3: selectedAddr.line3,
                    Line4: selectedAddr.line4,
                    County:selectedAddr.county,
                    PostCode:selectedAddr.postCode,
                    CountryCode:selectedAddr.countryCode,
                    VanityAddressName: selectedAddr.vanityaddressName
                };
                $.ajax({
                    type: 'POST',
                    url: self.urls.updateAddressUrl,
                    data: postCodeAddress,
                    success: function(response) {
                        const isAccepted = response.statusCode?.toLowerCase() === self.statusDescription.accepted;
                        window.location.href = isAccepted ? self.urls.personalDetailsPageUrl : self.urls.errorPageUrl;
                    },
                    error: function() {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            },
            allowCapsLetterOnly: function (e) {
                $(self.elements.label.invalidPostCodeMessage).addClass(self.css.hideElement);
                $(self.elements.label.emptyPostCodeMessage).addClass(self.css.hideElement);
                $(self.elements.label.savePostCodeInvalid).addClass(self.css.hideElement);
                const inputValue = e.target.value;
                e.target.value = inputValue.replace(/[^a-zA-Z0-9\s]/g, '')
                    .slice(0,self.constants.postCodeLength).toUpperCase();
            },
            formattedPostCode: function () {
                const postCodeValue = $(self.elements.textBox.postCode).val();
                if (!self.func.isValidPostCode()){
                    return;
                }
                self.func.hideErrorMessage();
                const formattedValue = $.trim(postCodeValue)
                    .replace(self.constants.ReplaceWhiteSpaceRegex, '')
                    .toUpperCase().split(self.constants.splitLastThreeRegex).join(' ');
                $(self.elements.textBox.postCode).val(formattedValue);
                self.func.validatePostCode($(self.elements.textBox.postCode).val());
            },
            validatePostCode: function (postCode) {
                $(self.elements.label.selectAddressErrorMessage).addClass(self.css.hideElement);
                $.ajax({
                    type: 'GET',
                    url: self.urls.validatePostCodeUrl+'?postCode='+postCode,
                    success: function(response) {
                        if(response !== null && response.generalAddressList !== null && response?.generalAddressList.length > 0) {
                            self.func.bindAddressResponse(response.generalAddressList);
                            $(self.elements.label.selectPostcodeAddressSection).removeClass(self.css.hideElement);
                            self.globalVariable.isSelectPopulated = true;
                        }
                        else {
                            $(self.elements.label.invalidPostCodeMessage).removeClass(self.css.hideElement);
                            self.globalVariable.isSelectPopulated = false;
                        }
                    },
                    error: function() {
                        $(self.elements.label.invalidPostCodeMessage).removeClass(self.css.hideElement);
                        self.globalVariable.isSelectPopulated = false;
                    }
                });
            },
            bindAddressResponse: function (addressList) {
                const saveAddress = $(self.elements.textBox.savedAddressLine4).val();
                self.func.bindMultilineAddressSection(saveAddress);
                const $select = $(self.elements.select.postCodeDropDown);
                $select.empty();

                const $defaultOpt = $('<option>')
                    .val('')
                    .text('Select Address')
                    .prop('selected', true)
                    .prop('disabled', true);
                $select.append($defaultOpt);

                addressList.forEach(function (addr, idx) {
                    const label = self.func.buildAddressLabel(addr);
                    const value = addr.addressIndex || String(idx);
                    const $opt = $('<option>')
                        .val(value)
                        .text(label)
                        .data(self.constants.address, addr);
                    $select.append($opt);
                });
            },
            buildAddressLabel: function (addr){
                const parts = [
                    addr.line1,
                    addr.line2,
                    addr.line3,
                    addr.line4,
                    addr.postCode
                ].filter(Boolean).map(s => s.trim());
                return parts.join(' ');
            },
            onPostCodeDropDownChange: function () {
                const selectedAddr = $(self.elements.select.postCodeDropDown).find(':selected').data(self.constants.address);
                $(self.elements.label.selectAddressErrorMessage).addClass(self.css.hideElement);
                if(selectedAddr != null){
                    self.func.bindMultilineAddressSection(selectedAddr.line4);
                }
            },
            bindMultilineAddressSection: function (value){
                const div = $(self.elements.div.multiLineAddressSection);
                div.empty();
                if (value) {
                    div.append($('<span>').text(value));
                }
            },
            isValidPostCode: function (){
                const postCodeValue = $(self.elements.textBox.postCode).val();
                if (!postCodeValue){
                    $(self.elements.label.emptyPostCodeMessage).removeClass(self.css.hideElement);
                    return false;
                }
                return true;
            },
            hideErrorMessage: function (){
                $(self.elements.label.savePostCodeInvalid).addClass(self.css.hideElement);
                $(self.elements.label.invalidPostCodeMessage).addClass(self.css.hideElement);
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('health-address-form' === $('#health-address-form').data('feature')) {
        window.UpdateAddressForm.Init();
    }
});
